import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, spacing, breakpoints } = useTheme();

  return {
    answer: css`
      padding-bottom: ${spacing.s};
    `,
    buttonNext: arrowContext => css`
      font-family: 'FS Dillon';
      width: 327px;
      height: 48px;
      background-color: ${colors.red};
      color: ${colors.white};
      border: 1px ${colors.red} solid;
      border-radius: 4px;
      margin-top: 2rem;
      font-size: 16px;
      &:focus-visible {
        outline: none;
        color: ${colors.border_black};
        border: 2px solid ${colors.border_black};
        background-color: ${colors.skip_yellow};
        text-decoration: underline;
      }

      ${arrowContext === false &&
      css`
        background-color: ${colors.border_grey};
        color: ${colors.next_grey};
        border: 1px ${colors.border_grey} solid;
        cursor: initial;
      `}

      ${arrowContext === true &&
      css`
        background-color: ${colors.red};
        color: ${colors.white};
        cursor: pointer;
      `}

  ${breakpoints.l} {
        width: 391px;
      }
      &:not(:disabled) {
        &:hover {
          background-color: ${colors.white} !important;
          color: #16161e !important;
          border: none;
        }
      }
    `,
    link: css`
      padding: ${spacing.xs};
    `,
    error: css`
      color: ${colors.red};
    `,
    locationInput: css`
      width: 327px;
      background-color: white;

      ${breakpoints.l} {
        width: 391px;
      }
    `,
  };
};
